import { DepotMessage } from '../types';

// Message du dépôt mocké
const mockDepotMessage: DepotMessage = {
  id: 'msg-1',
  message: "Chaque sortie doit être comptabilisée sur le chantier de destination, veuillez à bien vérifier la quantité de consommables sorties sur votre bon de commande.",
  createdBy: '2', // Responsable dépôt
  createdAt: '2024-12-10T08:00:00Z',
  isActive: true
};

class DepotMessageService {
  async getCurrentMessage(): Promise<DepotMessage | null> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockDepotMessage.isActive ? mockDepotMessage : null;
  }

  async updateMessage(message: string, userId: string): Promise<DepotMessage> {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const updatedMessage: DepotMessage = {
      id: mockDepotMessage.id,
      message,
      createdBy: userId,
      createdAt: new Date().toISOString(),
      isActive: true
    };
    
    // En réalité, cela mettrait à jour la base de données
    Object.assign(mockDepotMessage, updatedMessage);
    
    return updatedMessage;
  }

  async deactivateMessage(): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 300));
    mockDepotMessage.isActive = false;
  }
}

export const depotMessageService = new DepotMessageService();